import { TextareaAutosize } from '@mui/base';
import { Edit } from '@mui/icons-material';
import { IconButton } from '@mui/joy';
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import '../styles/chat.css';

const ChatSend = props => {
  const { message, editable, isEditing, onStartEdit, onCancelEdit, onSubmitEdit } = props;
  const [draft, setDraft] = useState(message.message);

  useEffect(() => {
    if (isEditing) {
      setDraft(message.message);
    }
  }, [isEditing, message.message]);

  const submit = () => {
    const texte = draft.trim();
    if (texte === '' || texte === message.message) {
      onCancelEdit();
      return;
    }
    onSubmitEdit(message.id, texte);
  };

  return (
    <Container className="chat-send" id={message.id}>
      <Row className="d-flex justify-content-center" style={{ color: 'grey', fontSize: '.7rem' }}>
        {props.date}
      </Row>
      <Row className="d-flex justify-content-end align-items-center">
        {editable && !isEditing && (
          <IconButton
            className="chat-edit-trigger col-sm-auto p-0"
            title="Modifier le message"
            variant="plain"
            onClick={onStartEdit}
          >
            <Edit sx={{ fontSize: '1rem', color: '#134491' }} />
          </IconButton>
        )}
        <div className="chat-box">
          <Container>
            <Row>
              <Col className="p-0 d-flex align-items-center" style={{ whiteSpace: 'break-spaces' }}>
                {isEditing ? (
                  <div className="chat-edit-form">
                    <TextareaAutosize
                      className="chat-edit-input"
                      autoFocus
                      value={draft}
                      onChange={e => setDraft(e.target.value)}
                      onKeyDown={e => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                          e.preventDefault();
                          submit();
                        }
                        if (e.key === 'Escape') {
                          onCancelEdit();
                        }
                      }}
                    />
                    <div className="d-flex justify-content-end pt-1">
                      <Button size="sm" variant="link" onClick={onCancelEdit}>
                        Annuler
                      </Button>
                      <Button size="sm" onClick={submit}>
                        Enregistrer
                      </Button>
                    </div>
                  </div>
                ) : (
                  <span>
                    {message.message}
                    {message.editedAt && <span className="chat-edited-marker">(modifié)</span>}
                  </span>
                )}
              </Col>
            </Row>
          </Container>
        </div>
      </Row>
    </Container>
  );
};

export default ChatSend;
